import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';

/**
 * Hook that returns placeholder text for the board selector based on selected boards
 *
 * @returns {string} Placeholder text to display:
 *  - If no boards selected: First board name or "Select Board" translation
 *  - If one board selected: Selected board name or "1 Board" translation
 *  - If multiple boards selected: Translation with count of selected boards
 */
const usePlaceholderText = (): string => {
  const { t } = useTranslation();
  const selectedBoardIds = useProcessAnalysisStore((state) => state.selectedBoards);
  const teams = useGlobalStore((state) => state.teams);

  if (selectedBoardIds.length === 0) {
    // Show first board name as default
    const defaultTeam = teams[0];
    const defaultBoard = defaultTeam?.subprojects[0];
    return defaultBoard?.name || t('process_analysis.main_section.select_board');
  }

  if (selectedBoardIds.length === 1) {
    // Find the selected board name
    for (const team of teams) {
      const board = team.subprojects.find((b) => b.id === selectedBoardIds[0]);
      if (board) {
        return board.name;
      }
    }
    return t('process_analysis.main_section.one_board');
  }

  // Multiple boards selected
  return t('process_analysis.main_section.boards_count', { count: selectedBoardIds.length });
};

export { usePlaceholderText };
